// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnsupportedBubble__content-ec7394 {
  background-color: inherit;
}

.UnsupportedBubble__bubble-cdbe33 {
  padding: 10px 12px 0;
}

.UnsupportedBubble__bubble-cdbe33:after {
  content: "";
  display: table;
  clear: both;
}

.UnsupportedBubble__sender-name-e168dd {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.UnsupportedBubble__status-bar-dcc55d {
  float: right;
  margin: 4px 0 10px 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/UnsupportedBubble/UnsupportedBubble.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,sBAAA;AACF","sourcesContent":[".content {\n  background-color: inherit;\n}\n\n.bubble {\n  padding: 10px 12px 0;\n}\n\n.bubble:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status-bar {\n  float: right;\n  margin: 4px 0 10px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `UnsupportedBubble__content-ec7394`,
	"bubble": `UnsupportedBubble__bubble-cdbe33`,
	"sender-name": `UnsupportedBubble__sender-name-e168dd`,
	"senderName": `UnsupportedBubble__sender-name-e168dd`,
	"status-bar": `UnsupportedBubble__status-bar-dcc55d`,
	"statusBar": `UnsupportedBubble__status-bar-dcc55d`
};
module.exports = ___CSS_LOADER_EXPORT___;
